export class MetricLead {
  createdAt?: Date;
  updatedAt?: Date;
  firstAssignedDate?: Date;
  firstUserAssigned?: string;
  firstInteractionDate?: Date;
  realResponseTime?: number;
  firstContactBussinessSeconds?: number;
  firstContactDate?: Date;
  endDefeatDate?: Date;
  onTrack?: string;
  transferred?: boolean;
  assignedDate?: Date;
  firstCallDate?: Date;
  callStartTime?: Date;
  inCall?: boolean;
  timesTransferred?: number;
  timesEdited?: number;
  timesWithoutCallResponse?: number;
  durationWithoutCallResponse?: number;
  timesWithCallResponse?: number;
  durationWithCallResponse?: number;
  whatsappsSent?: number;
  emailsSent?: number;
  emailsReceived?: number;
  remindersScheduled?: number;
  visitScheduled?: number;
  totalInteractions?: number;
  firstContactUserName?: string;
}
